var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.930664,
    y: 0.336914,
    width: 10.3418,
    height: 10.3418,
    rx: 5.17089,
    fill: "#255F9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70169 5.34208L4.59347 2.23438L3.8623 2.96554L6.24092 5.34415L3.8623 7.71914L4.59347 8.45031L7.70169 5.34208Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/Arrowright.89e26d4fb66d963503ab70a278dfc9d0.svg";
export { ForwardRef as ReactComponent };